<script setup>
import {plantListItems} from '~/utils/listing-schema.mjs';
const route = useRoute();
const category = computed(() => ({slug: {_eq: route.params.subcategory}}));
const {query: catalogQuery} = await useCatalogQuery(category);
const currentPage = computed(() => catalogQuery.value.page);
const pagination = usePagination(currentPage, 48);
const variables = computed(() => ({
    slug: route.params.subcategory,
    where: catalogQuery.value.where,
    order_by: {[catalogQuery.value.sort]: 'desc'},
    ...pagination.value,
    parentId: false,
    includeSeeds: !catalogQuery.value.search,
}));
const {data, fetching, error} = await useGetCategoriesQuery({variables});
if (error.value) throw createError({statusCode: 503, message: 'Не удалось загрузить каталог.'});
if (!data.value?.uogorod_seed_categories?.[0]) throw createError({statusCode: 404, message: 'Категория не найдена'});
const {data: categoryNames, error: categoryNamesError} = await useFetch('/api/categories/options', {query: computed(() => ({slug: route.params.subcategory}))});
if (categoryNamesError.value) throw createError({statusCode: 503, message: 'Не удалось загрузить названия категории.'});
useCatalogPageBounds({
    page: currentPage,
    totalPages: () => Number(data.value?.uogorod_seed_categories?.[0]?.seeds_aggregate?.aggregate?.count || 0) / 48,
    pending: () => !!catalogQuery.value.search || fetching.value,
    sources: [data],
});
const breadcrumbs = computed(() => [
    {title: 'Главная', href: '/'},
    {title: 'Каталог', href: '/catalog'},
    {title: data.value.uogorod_seed_categories[0].parent.title, href: '/catalog/' + data.value.uogorod_seed_categories[0].parent.slug},
    {title: data.value.uogorod_seed_categories[0].title, href: '/catalog/' + data.value.uogorod_seed_categories[0].parent.slug + '/' + data.value.uogorod_seed_categories[0].slug},
]);
useCatalogSeo(() => ({
    primaryName: data.value.uogorod_seed_categories[0].title,
    alternateNames: categoryNames.value?.[0]?.id === data.value.uogorod_seed_categories[0].id ? categoryNames.value[0].synonyms : [],
    title: route.meta.title ? String(route.meta.title).replace('%category%', data.value.uogorod_seed_categories[0].title) : data.value.uogorod_seed_categories[0].title + ' — каталог',
    description: data.value.uogorod_seed_categories[0].title + ' в каталоге Умного Огорода: описания, характеристики, фотографии и отзывы садоводов. Сравнивайте варианты и делитесь опытом.',
    page: currentPage.value,
    query: catalogQuery.value.normalizedQuery,
    data: {total: Number(data.value.uogorod_seed_categories[0].seeds_aggregate?.aggregate?.count || 0)},
    breadcrumbs: breadcrumbs.value,
    items: catalogQuery.value.search ? [] : plantListItems(data.value.uogorod_seed_categories[0].seeds),
    offset: (currentPage.value - 1) * 48,
}));
</script>


<template>
	<CommonBreadcrumbs :links="breadcrumbs" />
	<CatalogCategories :title="(route.meta?.title ?? '%category%').replace('%category%', data.uogorod_seed_categories[0].title)" :category="category">
		<template v-if="data.uogorod_seed_categories[0].description" #description>
			<p class="py-0 my-0">{{ data.uogorod_seed_categories[0].description }}</p>
		</template>
		<template v-if="data.uogorod_seed_categories[0].seeds.length">
			<CatalogSeedsList :discovery="true" :seeds="data.uogorod_seed_categories[0].seeds || []" />
			<CommonPagination class="mt-4" :current="currentPage" :total="data.uogorod_seed_categories[0].seeds_aggregate.aggregate.count / pagination.limit" />
		</template>
	</CatalogCategories>
</template>
